<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span
                        >Remessa TCEPE - Modelo de Planilha de Itens do IJ</span
                    >
                </h4>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <div>
                    <b-row>
                        <b-col sm="12" md="12">
                            <b-form-group>
                                <label
                                    for="selectListaContratos"
                                    class="required"
                                    >Contrato</label
                                >
                                <model-list-select
                                    id="selectListaContratos"
                                    :list="listaContratos"
                                    v-model="idContratoSelecionado"
                                    option-value="idContrato"
                                    option-text="vcCodigoEstruturado"
                                    placeholder="Selecione um contrato"
                                    @input="$v.idContratoSelecionado.$touch()"
                                ></model-list-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label for="inputNumeroDoItem" class="required"
                                    >Número do Item</label
                                >
                                <b-input-group>
                                    <b-form-input
                                        id="inputNumeroDoItem"
                                        type="number"
                                        min="1"
                                        step="1"
                                        placeholder="Número do Item"
                                        v-model="numeroDoItem"
                                        @input.native="$v.numeroDoItem.$touch()"
                                        @focus="$v.numeroDoItem.$touch()"
                                    ></b-form-input>
                                    <div
                                        v-if="
                                            $v.numeroDoItem.$dirty &&
                                            $v.numeroDoItem.$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        Número do Item é obrigatório
                                    </div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label
                                    for="selectMaterialServico"
                                    class="required"
                                    >Material Serviço</label
                                >
                                <b-form-select
                                    id="selectMaterialServico"
                                    :options="listaMaterialServico"
                                    v-model="materialServico"
                                    text-field="nome"
                                    value-field="codigo"
                                    @input.native="$v.materialServico.$touch()"
                                ></b-form-select>
                                <b-form-invalid-feedback
                                    >Material Serviço é
                                    obrigatório</b-form-invalid-feedback
                                >
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label
                                    for="selectFonteReferencia"
                                    class="required"
                                    >Fonte de Referência</label
                                >
                                <b-form-select
                                    id="selectFonteReferencia"
                                    :options="listaFonteDeReferencia"
                                    v-model="fonteDeReferencia"
                                    text-field="nome"
                                    value-field="codigo"
                                    @input.native="
                                        $v.fonteDeReferencia.$touch()
                                    "
                                ></b-form-select>
                                <b-form-invalid-feedback
                                    >Fonte de Referência é
                                    obrigatório</b-form-invalid-feedback
                                >
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label for="dataReferencia" class="required"
                                    >Data de Referência</label
                                >
                                <date-picker
                                    id="dataReferencia"
                                    v-model="dataDeReferencia"
                                    :config="$datePickerOptions"
                                    v-mask="'##/##/####'"
                                    @input.native="$v.dataDeReferencia.$touch()"
                                    :state="stateInputDataReferencia"
                                ></date-picker>
                                <b-form-invalid-feedback
                                    >Data de Referência é
                                    obrigatório</b-form-invalid-feedback
                                >
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label
                                    for="selectCodigoReferencia"
                                    class="required"
                                    >Código de Referência</label
                                >
                                <b-input-group>
                                    <b-form-input
                                        id="inputCodigoReferencia"
                                        type="text"
                                        maxlength="100"
                                        placeholder="Código de Referência"
                                        @input.native="
                                            $v.codigoDeReferencia.$touch()
                                        "
                                        @focus="$v.codigoDeReferencia.$touch()"
                                        v-model="codigoDeReferencia"
                                    ></b-form-input>
                                    <div
                                        v-if="
                                            $v.codigoDeReferencia.$dirty &&
                                            $v.codigoDeReferencia.$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        {{
                                            $v.codigoDeReferencia.required ===
                                            false
                                                ? 'Código de Referência é obrigatório'
                                                : 'Máx. 100 caracteres'
                                        }}
                                    </div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label
                                    for="inputUnidadeDeMedida"
                                    class="required"
                                    >Unidade Medida</label
                                >
                                <b-form-input
                                    id="inputUnidadeDeMedida"
                                    type="text"
                                    maxlength="10"
                                    placeholder="Unidade Medida"
                                    @input.native="$v.unidadeDeMedida.$touch()"
                                    @focus="$v.unidadeDeMedida.$touch()"
                                    v-model="unidadeDeMedida"
                                ></b-form-input>
                                <div
                                    v-if="
                                        $v.unidadeDeMedida.$dirty &&
                                        $v.unidadeDeMedida.$invalid
                                    "
                                    class="invalid-feedback d-block"
                                >
                                    {{
                                        $v.unidadeDeMedida.required === false
                                            ? 'Unidade Medida é obrigatório'
                                            : 'Máx. 10 caracteres'
                                    }}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label for="moQuantidade" class="required"
                                    >Quantidade</label
                                >
                                <money
                                    id="moQuantidade"
                                    v-model="quantidade"
                                    v-bind="quantidadeConfig"
                                    class="form-control text-right"
                                    @input.native="$v.quantidade.$touch()"
                                    @focus="$v.quantidade.$touch()"
                                ></money>
                                <div
                                    v-if="
                                        $v.quantidade.$dirty &&
                                        $v.quantidade.$invalid
                                    "
                                    class="invalid-feedback d-block"
                                >
                                    Quantidade é obrigatório
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label for="moValorUnitario" class="required"
                                    >Valor Unitário</label
                                >
                                <b-input-group>
                                    <money
                                        id="moValorUnitario"
                                        v-model="valorUnitario"
                                        v-bind="money"
                                        class="form-control text-right"
                                        @input.native="
                                            $v.valorUnitario.$touch()
                                        "
                                        @focus="$v.valorUnitario.$touch()"
                                    ></money>
                                    <div
                                        v-if="
                                            $v.valorUnitario.$dirty &&
                                            $v.valorUnitario.$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        Valor Unitário é obrigatório
                                    </div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="12">
                            <b-form-group>
                                <label for="descricao" class="required"
                                    >Descrição do Item</label
                                >
                                <b-form-textarea
                                    v-model="descricao"
                                    :rows="3"
                                    @input.native="$v.descricao.$touch()"
                                    @focus="$v.descricao.$touch()"
                                    :state="stateInputDescricao"
                                    maxlength="8000"
                                ></b-form-textarea>
                                <div
                                    v-if="
                                        $v.descricao.$dirty &&
                                        $v.descricao.$invalid
                                    "
                                    class="invalid-feedback d-block"
                                >
                                    Descrição do Item é obrigatório
                                </div>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label for="moValorTotal" class="required"
                                    >Valor Total</label
                                >
                                <b-input-group>
                                    <money
                                        id="moValorTotal"
                                        v-model="valorTotal"
                                        v-bind="{ ...money, precision: 2 }"
                                        class="form-control text-right"
                                        @input.native="$v.valorTotal.$touch()"
                                        @focus="$v.valorTotal.$touch()"
                                    ></money>
                                    <div
                                        v-if="
                                            $v.valorTotal.$dirty &&
                                            $v.valorTotal.$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        Valor Total é obrigatório
                                    </div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label for="textoBDI" class="required"
                                    >BDI</label
                                >
                                <b-form-input
                                    id="textoBDI"
                                    type="text"
                                    maxlength="10"
                                    placeholder="BDI"
                                    @input.native="$v.bdi.$touch()"
                                    @focus="$v.bdi.$touch()"
                                    v-model="bdi"
                                ></b-form-input>
                                <div
                                    v-if="$v.bdi.$dirty && $v.bdi.$invalid"
                                    class="invalid-feedback d-block"
                                >
                                    BDI é obrigatório
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label for="selectIndiceDeAtualizacoes"
                                    >Índice de Atualizações</label
                                >
                                <b-form-select
                                    id="selectIndiceDeAtualizacoes"
                                    :options="listaIndiceDeAtualizacoes"
                                    v-model="indiceAtualizacoes"
                                    text-field="nome"
                                    value-field="codigo"
                                    @input.native="
                                        $v.indiceAtualizacoes.$touch()
                                    "
                                ></b-form-select>
                                <b-form-invalid-feedback
                                    >Índice de Atualizações é
                                    obrigatório</b-form-invalid-feedback
                                >
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label
                                    for="moPercentualContratado"
                                    class="required"
                                    v-bind:class="{
                                        required: campoPercentualObrigatorio
                                    }"
                                    >Percentual Contratado</label
                                >
                                <money
                                    id="moPercentualContratado"
                                    v-model="percentualContratado"
                                    v-bind="quantidadeConfig"
                                    class="form-control text-right"
                                    @input.native="
                                        $v.percentualContratado.$touch()
                                    "
                                ></money>
                                <div
                                        v-if="
                                            $v.valorTotal.$dirty &&
                                            $v.valorTotal.$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        Percentual Contratado é obrigatório
                                </div>                                
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
            </b-card-body>
            <b-card-footer>
                <!-- <b-button variant="warning" @click.stop="voltar()"  class="mr-2">
                    <span>
                        <i class="fa fa-history mr-2"></i> Voltar
                    </span>
                </b-button> -->
                <b-button
                    variant="primary"
                    class="mr-2"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="salvar()"
                >
                    <span>
                        <i class="fa fa-file-o mr-2"></i> Emitir Planilha
                    </span>
                </b-button>
            </b-card-footer>
        </b-card>
    </div>
</template>
<script>
import { ModelListSelect } from 'vue-search-select'
import { maxLength } from 'vuelidate/lib/validators'
import { required, minValue } from 'vuelidate/lib/validators'
import GestaoJuridicaServicos from '../../GestaoJuridicaServicos'

export default {
    components: {
        ModelListSelect
    },

    methods: {
        calcularValorTotal() {
            const qtd = Number(this.quantidade) || 0
            const vu = Number(this.valorUnitario) || 0
            this.valorTotal = qtd * vu
        },

        salvar() {
            const dto = {
                CnpjContratada: this.onlyDigits(this.contrato.fornecedor.cnpj),
                NumeroItem: this.numeroDoItem,
                MaterialServico: this.materialServico,
                FonteReferencia: this.fonteDeReferencia,
                DataReferencia: this.toIsoDate(this.dataDeReferencia),
                CodigoReferencia: this.codigoDeReferencia,
                UnidadeMedida: this.unidadeDeMedida,
                Quantidade: this.converterParaFloat(this.quantidade),
                DescricaoItem: this.descricao,
                ValorUnitario: this.converterParaFloat(this.valorUnitario),
                ValorTotal: this.converterParaFloat(this.valorTotal),
                Bdi: this.bdi,
                IndiceAtualizacoes: this.indiceAtualizacoes,
                PercentualContratado: this.converterParaFloat(
                    this.percentualContratado
                )
            }

            this.$store.dispatch('addRequest')

            GestaoJuridicaServicos.GerarPlanilhaRelatorioContratoIj(dto)
                .then((res) => {
                    this.abrirListaDePlanilha(dto.CnpjContratada)
                    this.$toast.success(
                        'Relatório Salvo Com Sucesso.',
                        'OK',
                        this.$toastConfig.success
                    )
                })
                .catch(() => {
                    this.$toast.error(
                        'Falha ao enviar ao backend.',
                        'ERRO',
                        this.$toastConfig.error
                    )
                })
                .finally(() => this.$store.dispatch('removeRequest'))
        },

        toIsoDate: (s) => {
            // aceita "dd/MM/yyyy" do date-picker e converte pra "yyyy-MM-dd"
            if (!s) return null
            const [dd, mm, yyyy] = String(s).split('/')
            if (!dd || !mm || !yyyy) return null
            return `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`
        },

        onlyDigits: (s) => (s || '').replace(/\D+/g, ''),

        verificarCampoPreenchido(value) {
            if (value == null || value == '' || value == undefined) return false
            else return true
        },

        abrirListaDePlanilha(cnpj) {
            this.$router.push({
                name: `Contratos_Relatorios_IJ`,
                params: {
                    cnpj: this.onlyDigits(cnpj)
                }
            })
        },

        obterContratos() {
            this.$store.dispatch('addRequest')
            GestaoJuridicaServicos.obterContratosVigentes().then((response) => {
                if (response) {
                    if (response.success) {
                        this.listaContratos = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter lista de contratos!',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterDadosContrato() {
            this.$store.dispatch('addRequest')
            GestaoJuridicaServicos.obterContratosPorId(
                this.idContratoSelecionado
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.preencherDadosContrato(response.data)
                    } else {
                        this.$toast.error(
                            'Erro ao obter contrato!',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        preencherDadosContrato(contrato) {
            // preencher dados com valores vindos do contrato
            // this.numeroDoItem = ?
            // this.materialServico = ?
            // this.descricao = ?
            // this.unidadeDeMedida = ?
            // this.quantidade = ?
            // this.valorUnitario = ?
            // this.valorTotal = contrato.nuValorGlobalContrato

            // testes apagar antes de commitar
            // this.numeroDoItem = 1
            // this.materialServico = "M"
            // this.descricao = "TESTE"
            // this.fonteDeReferencia = this.listaFonteDeReferencia[0].codigo
            // this.dataDeReferencia = "18/09/2025"
            // this.codigoDeReferencia = 45
            // this.unidadeDeMedida = "T"
            // this.quantidade = 5
            // this.valorUnitario = 56.59
            // this.bdi = "T"
            // this.indiceDeAtualizacao = this.listaIndiceDeAtualizacoes[0].codigo

            this.contrato = contrato
        },

        validarCodigoReferencia(value) {
            if (!value) return false

            try {
                GestaoJuridicaServicos.validarCodigoReferencia().then(
                    (response) => {
                        if (response === true) {
                            return true
                        }
                        return false
                    }
                )
            } catch (err) {
                console.error('Erro na validação externa:', err)
                return false
            }
        },
        obterListaFonteReferencia() {
            this.$store.dispatch('addRequest')
            GestaoJuridicaServicos.obterFonteDeReferencias().then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.listaFonteDeReferencia = response.data
                        } else {
                            this.$toast.error(
                                'Erro ao obter Fonte de Referência',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterListaIndiceAtualizacoes() {
            this.$store.dispatch('addRequest')
            GestaoJuridicaServicos.obterListaIndiceAtualizacoes().then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.listaIndiceDeAtualizacoes = response.data
                        } else {
                            this.$toast.error(
                                'Erro ao obter Índice de Atualizações',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        converterParaFloat(valorString) {
            const normalizado = valorString
                .toString()
                .replace(/\./g, '')
                .replace(',', '.')
            return parseFloat(normalizado)
        },

        limparCampos() {
            this.numeroDoItem = null
            this.materialServico = null
            this.fonteDeReferencia = null
            this.dataDeReferencia = null
            this.codigoDeReferencia = null
            this.unidadeDeMedida = null
            this.quantidade = 0
            this.descricao = ''
            this.valorUnitario = 0
            this.valorTotal = 0
            this.bdi = null
            this.indiceAtualizacoes = null
            this.percentualContratado = 0
            this.contrato = null
        }
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        stateInputDataReferencia() {
            if (this.$v)
                if (
                    this.$v.dataDeReferencia.$invalid &&
                    this.$v.dataDeReferencia.$dirty
                )
                    return false
            return null
        },

        stateInputDescricao() {
            if (this.$v)
                if (this.$v.descricao.$invalid && this.$v.descricao.$dirty)
                    return this.verificarCampoPreenchido(this.descricao)
                        ? null
                        : false
            return null
        },

        dataDeReferenciaValida() {
            if (this.verificarCampoPreenchido(this.dataDeReferencia)) {
                const data = this.$moment(this.dataDeReferencia, 'DD/MM/YYYY')
                const limiteInferior = this.$moment('01/01/2000', 'DD/MM/YYYY')
                const hoje = this.$moment()

                return (
                    data.isSameOrAfter(limiteInferior) &&
                    data.isSameOrBefore(hoje)
                )
            }
            return false
        },
        // Validação de campos

        // Campos com obrigatóriedade sujeita a mudança de acordo com regra de negócio
        campoPercentualObrigatorio() {
            return false
        }
    },
    validations: {
        idContratoSelecionado: {
            required
        },
        numeroDoItem: {
            required
        },
        materialServico: {
            verificarPreenchimento() {
                return this.verificarCampoPreenchido(this.materialServico)
            }
        },
        fonteDeReferencia: {
            verificarPreenchimento() {
                return this.verificarCampoPreenchido(this.fonteDeReferencia)
            }
        },
        dataDeReferencia: {
            dataValida() {
                return this.dataDeReferenciaValida
            }
        },
        codigoDeReferencia: {
            required,
            maxLength: maxLength(100)
        },
        unidadeDeMedida: {
            required,
            maxLength: maxLength(10)
        },
        descricao: {
            required,
            maxLength: maxLength(250)
        },
        unidadeDeMedida: {
            required,
            maxLength: maxLength(10)
        },
        quantidade: {
            required
        },
        valorUnitario: {
            verificarPreenchimento() {
                return this.verificarCampoPreenchido(this.valorUnitario)
            }
        },
        valorTotal: {
            verificarPreenchimento() {
                return this.verificarCampoPreenchido(this.valorTotal)
            }
        },
        bdi: {
            verificarPreenchimento() {
                return this.verificarCampoPreenchido(this.bdi)
            }
        },
        indiceAtualizacoes: {
            verificarPreenchimento() {
                return true
            }
        },
        percentualContratado: {
            verificarPreenchimento() {
                return this.campoPercentualObrigatorio
                    ? this.verificarCampoPreenchido(this.percentualContratado)
                    : true
            }
        }
    },
    data() {
        return {
            erros: [],
            listaMaterialServico: [
                { codigo: 'M', nome: 'M' },
                { codigo: 'S', nome: 'S' }
            ],
            listaFonteDeReferencia: [],
            listaIndiceDeAtualizacoes: [],
            listaContratos: [],
            idContratoSelecionado: null,
            contrato: null,
            numeroDoItem: null,
            materialServico: null,
            fonteDeReferencia: null,
            dataDeReferencia: null,
            codigoDeReferencia: null,
            unidadeDeMedida: null,
            quantidade: 0,
            descricao: '',
            valorUnitario: 0,
            valorTotal: 0,
            bdi: null,
            indiceAtualizacoes: null,
            percentualContratado: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            quantidadeConfig: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 0,
                masked: false
            }
        }
    },

    created() {
        this.obterListaFonteReferencia(),
            this.obterListaIndiceAtualizacoes(),
            this.obterContratos()
    },

    watch: {
        codigoDeReferencia(v) {
            if (typeof v === 'string' && v.length > 100) {
                this.codigoDeReferencia = v.slice(0, 100)
            }
        },
        quantidade() {
            this.calcularValorTotal()
        },
        valorUnitario() {
            this.calcularValorTotal()
        },
        idContratoSelecionado() {
            if (
                this.idContratoSelecionado !== null &&
                this.idContratoSelecionado !== undefined &&
                this.idContratoSelecionado !== ''
            ) {
                this.limparCampos()
                this.obterDadosContrato()
            } else {
                this.limparCampos()
                this.$v.$reset()
            }
        }
    }
}
</script>
